export const headerConstants = {
  PAGE_DASHBOARD: "PAGE_DASHBOARD",
  PAGE_NOTES: "PAGE_NOTES",
  PAGE_ALERTS: "PAGE_ALERTS",
  PAGE_DEVICES: "PAGE_DEVICES",
  PAGE_REPORTS: "PAGE_REPORTS"
};



// WEBPACK FOOTER //
// ./src/_constants/header.constants.js